import * as React from 'react';

function Same(props) {
	return (
		<svg
			width={19}
			height={9}
			viewBox="0 0 19 9"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5 1H1v10h21V1h-4l-3.5 2-3-2-3 2L5 1z"
				fill="url(#prefix__paint0_linear)"
			/>
			<path
				d="M1 1h4.25L8.5 3l3-2 3 2L18 1h4"
				stroke="#A4A4A8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<defs>
				<linearGradient
					id="prefix__paint0_linear"
					x1={12}
					y1={-4}
					x2={12}
					y2={11}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#848488" />
					<stop offset={1} stopColor="#848488" stopOpacity={0} />
				</linearGradient>
			</defs>
		</svg>
	);
}

export default Same;
